import { apiPrefix } from "@/config/config";
import { api } from "../interceptor/api.interceptor";

class CommonService {
  static async getAllClasses() {
    return await api
      .get(`/${apiPrefix}/classes`)
      .then((res) => res?.data?.data);
  }

  static async getProgamClasses(slug) {
    return await api
      .get(`/${apiPrefix}/program/${slug}/classes`)
      .then((res) => res?.data?.data);
  }

  static async getAllGroups() {
    return await api.get(`/${apiPrefix}/groups`).then((res) => res?.data?.data);
  }

  static async getAllDivisions() {
    return await api
      .get(`/${apiPrefix}/divisions`)
      .then((res) => res?.data?.data);
  }

  static async searchCourses(searchText) {
    return await api
      .get(`/${apiPrefix}/courses/search`, {
        params: { search: searchText },
      })
      .then((res) => res?.data?.data);
  }

  static async getDistrictsByDivision(divisionId) {
    return await api
      .get(`/${apiPrefix}/districts/${divisionId}`)
      .then((res) => res?.data?.data);
  }

  static async getThanasByDistrict(districtId) {
    return await api
      .get(`/${apiPrefix}/thanas/${districtId}`)
      .then((res) => res?.data?.data);
  }

  static async getInstitutes() {
    return await api
      .get(`/${apiPrefix}/institutes`)
      .then((res) => res?.data?.data);
  }

  static async getAllAcademicExam() {
    return await api
      .get(`/${apiPrefix}/getAllAcademicExam`)
      .then((res) => res?.data?.data);
  }

  static async getAllGruop() {
    return await api
      .get(`/${apiPrefix}/getAllGruop`)
      .then((res) => res?.data?.data);
  }
  static async getBlogs(params) {
    return await api
      .get(`/${apiPrefix}/blogs`, { params })
      .then((res) => res?.data?.data)
      .catch((err) => {
        console.error("Failed to fetch Blogs:", err);
        throw err;
      });
  }

  // static async getBlogs(params) {
  //   return await api.get(`/${apiPrefix}/blogs`,{params}).then((res) => res?.data?.data);
  // }
  static async getblogCategory() {
    return await api
      .get(`/${apiPrefix}/getBlogCategory`)
      .then((res) => res?.data?.data);
  }

  static async getBlogBySlug(slug) {
    return await api
      .get(`/${apiPrefix}/blogs/${slug}`)
      .then((res) => res?.data?.data);
  }
  static async getMostRecentBlog(id) {
    return await api
      .get(`/${apiPrefix}/getMostRecentBlog/${id}`)
      .then((res) => res?.data?.data);
  }

  // FAQs
  static async getFaqs() {
    return await api.get(`/${apiPrefix}/faqs`).then((res) => res?.data?.data);
  }

  static async getFaqById(id) {
    return await api
      .get(`/${apiPrefix}/faqs/${id}`)
      .then((res) => res?.data?.data);
  }
  static async checkPhone(phone) {
    return await api
      .post(`/${apiPrefix}/checkPhone/${phone}`)
      .then((res) => res?.data?.data);
  }

  // Pages
  static async getPages() {
    return await api.get(`/${apiPrefix}/pages`).then((res) => res?.data?.data);
  }

  static async getAbout() {
    return await api.get(`/${apiPrefix}/about`).then((res) => res?.data?.data);
  }

  static async getPageBySlug(slug) {
    try {
      return await api
        .get(`/${apiPrefix}/pages/${slug}`)
        .then((res) => res?.data?.data);
    } catch (error) {}
  }

  static async postContact(formData) {
    return await api
      .post(`/${apiPrefix}/contact`, formData)
      .then((res) => res?.data?.data);
  }

  // Pages
  static async getProfessions() {
    return await api
      .get(`/${apiPrefix}/professions`)
      .then((res) => res?.data?.data);
  }
  static async getBloodGruop() {
    return await api
      .get(`/${apiPrefix}/blood-groups`)
      .then((res) => res?.data?.data);
  }

  static async getAllAcademicExam() {
    return await api
      .get(`/${apiPrefix}/getAllAcademicExam`)
      .then((res) => res?.data?.data);
  }

  static async getAllThanas() {
    return await api
      .get(`/${apiPrefix}/getAllThanas`)
      .then((res) => res?.data?.data);
  }

  static async getAllInstitutes() {
    return await api
      .get(`/${apiPrefix}/getAllInstitutes`)
      .then((res) => res?.data?.data);
  }

  static async getAllDistricts() {
    return await api
      .get(`/${apiPrefix}/getAllDistricts`)
      .then((res) => res?.data?.data);
  }
  static async getAllBranch(params = {}) {
    return await api
      .get(`/${apiPrefix}/getAllBranch`, { params })
      .then((res) => res?.data.data);
  }

  static async getAllDivisions() {
    return await api
      .get(`/${apiPrefix}/getAllDivisions`)
      .then((res) => res?.data?.data);
  }

  static async getAllBoards() {
    return await api
      .get(`/${apiPrefix}/getAllBoards`)
      .then((res) => res?.data?.data);
  }

  static async getNotices(params = {}) {
    return await api
      .get(`/${apiPrefix}/notices`, { params })
      .then((res) => res?.data.data);
  }

  static async getNoticeDetails(slug) {
    return await api
      .get(`/${apiPrefix}/notices/${slug}`)
      .then((res) => res?.data?.data);
  }

   static async getBranchDetails(slug) {
    return await api
      .get(`/${apiPrefix}/branches/${slug}`)
      .then((res) => res?.data?.data);
  }

}

export default CommonService;
